const { library, dom } = require("@fortawesome/fontawesome-svg-core");
const { faPlus } = require("@fortawesome/pro-regular-svg-icons/faPlus");
const { faMinus } = require("@fortawesome/pro-regular-svg-icons/faMinus");
const { faAngleDown } = require("@fortawesome/pro-regular-svg-icons/faAngleDown");

library.add(faAngleDown, faPlus, faMinus);
dom.watch();
